import { graphql, useStaticQuery } from 'gatsby';

export function useOwnersInfo(department) {
  const {
    allOwnersInfoJson: { nodes: items },
  } = useStaticQuery(graphql`
    query {
      allOwnersInfoJson {
        nodes {
          ctaImage {
            childImageSharp {
              gatsbyImageData(quality: 90, placeholder: NONE, width: 422, height: 416)
            }
          }
          linkedin
          name
          ownerDepartment
          photo
          position {
            de
            en
            ae
          }
        }
      }
    }
  `);

  if (department) {
    return items.find(({ ownerDepartment }) => ownerDepartment === department);
  }

  return items;
}
